import { useState, useRef } from "react";
import "./Sustainability25.scss";
import Banner from "../../../Common/Banner/Banner";
import { SUSTAINABILITY_25 } from "../../Sustainability/SustainabilityData";
import TwoColumnLayout from "../../../Common/TwoColumnLayout/TwoColumnLayout";
import Modal from "../../../Common/Modal/modal";
import iconPathURL from "../../../Common/iconPath";

const iconPath = process.env.PUBLIC_URL + "/assets/images/";

export default function Suatainability25() {
  const agendaRef = useRef(null);
  const speakerRef = useRef(null);

  const sustainabilityTable = () => {
    return (
      <div ref={agendaRef} className={"table-content"}>
        <div className="first-table">
          <h2 className={"agenda-text-24"}>Agenda</h2>
        </div>

        <div className="sustainability-container">
          <div className="time-column time-text">Time</div>
          <div className="session-column time-text">Session</div>
        </div>

        <>
          {SUSTAINABILITY_25.agenda?.map((item) => (
            <div className="row contents sustainability-wrapper">
              <div className="time-coulmn-data">{item.date}</div>
              <div className="session-column-data">{item.session}</div>
            </div>
          ))}
        </>
      </div>
    );
  };

  const handleRegisterNow = () => {
    const registerUrl =
      "https://www.mbrdi.co.in/assets/docs/Sustainability%20Dialogue%20India%202024%20-%20Press%20Release.pdf";
    window.open(registerUrl, "_blank");
  };

  return (
    <div className="sustain-container">
      {/* {modalSpeaker()} */}
      <div>
        <Banner
          imgSrc={iconPath + "sustainability-25/sustain_25.png"}
          title=""
        />
        <div className="btn-container">
          {/* <button onClick={handleRegisterNow} className="register-now-btn">
            Read the Press Announcement
          </button> */}
        </div>
      </div>
      {sustainabilityTable()}
    </div>
  );
}
